import { Box, Typography, TextField, Button } from "@mui/material";
import RichTextEditor from "../../components/RichTextEditor";

export default function DescriptionImageSection({
  values = {},
  setValues = () => {},
}) {
  const safeMeta = values.metafields || {};

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setValues((prev) => ({
      ...prev,
      image: URL.createObjectURL(file),
      imageFile: file,
    }));
  };

  const handleRemoveImage = () => {
    setValues((prev) => ({
      ...prev,
      image: null,
      imageFile: null,
      removeImage: true,
    }));
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Description & Media
      </Typography>

      {/* Description */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" gutterBottom>
          Description
        </Typography>
        <Box
          sx={{
            border: "1px solid rgba(0,0,0,0.23)",
            borderRadius: 1,
            p: 2,
          }}
        >
          <RichTextEditor
            value={values.description}
            onChange={(val) =>
              setValues((prev) => ({ ...prev, description: val }))
            }
          />
        </Box>
      </Box>

      {/* Image Box */}
      <Box sx={{ mb: 2 }}>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: 1,
            bgcolor: "#f5f5f5",
            height: 300,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2,
          }}
        >
          {values.image && (
            <Box
              sx={{
                border: "1px solid #aaa",
                borderRadius: 2,
                overflow: "hidden",
                width: 260,
                bgcolor: "#fff",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img
                src={typeof values.image === "string" ? values.image : URL.createObjectURL(values.image)}
                alt="Preview"
                style={{
                  width: "160px",
                  height: "auto",
                  display: "block",
                  borderRadius: "8px",
                }}
              />
            </Box>
          )}
        <Box sx={{ display: "flex", gap: 2 }}>
          <Button variant="contained" component="label">
            Upload Image
            <input
              type="file"
              hidden
              accept="image/*"
              onChange={handleImageUpload}
            />
          </Button>

            {values.image && (
              <Button
                variant="outlined"
                onClick={handleRemoveImage}
              >
                Remove Image
              </Button>
            )}
          </Box>
          {values.image && (
            <Typography
              variant="body2"
              sx={{
                textAlign: "center",
                wordBreak: "break-all",
              }}
            >
              {values.image.name}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Video URL */}
      <Box sx={{ mt: 2 }}>
        <TextField
          label="Video URL"
          value={safeMeta.video_url || ""}
          onChange={(e) =>
            setValues((prev) => ({
              ...prev,
              metafields: {
                ...prev.metafields,
                video_url: e.target.value,
              },
            }))
          }
          fullWidth
          size="small"
          slotProps={{
            inputLabel: { shrink: true },
          }}
        />
      </Box>
    </Box>
  );
}